<template>
	<div>
		<p>
			<!-- We would like to thank,.toLowerCase() -->
			{{
				selectRandom([
					"We would like to thank,",
					"We wish to express our gratitude to ",
					"Our sincere thanks go to ",
					"We appreciate the efforts of ",
					"We extend our thanks to ",
					" We would like to convey our gratitude towards ",
					"Heartfelt thanks to "
				])
			}}
			<span v-if="$tera.project.designhelp && $tera.project.designhelp.length">
				{{ joinArrayWithAnd(formatSelectMulti($tera.project.designhelp)) }}
				for help designing the search strategy
			</span>
			<span v-if="$tera.project.statistical && $tera.project.statistical.length">
				,
			</span>
			<span v-if="$tera.project.statistical && $tera.project.statistical.length">
				{{ joinArrayWithAnd(formatSelectMulti($tera.project.statistical)) }}
				for help with the statistical analysis
			</span>
			<span v-if="$tera.project.manuscript && $tera.project.manuscript.length">
				,
			</span>
			<span v-if="$tera.project.manuscript && $tera.project.manuscript.length">
				and {{ joinArrayWithAnd(formatSelectMulti($tera.project.manuscript)) }}
				for providing feedback on the draft manuscript
			</span>
			<span>
				.
			</span>
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputAcknowledgement",
	mixins: [OutputMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
